export default {
  BODY: "body",
  BODY_LF: "bodyLongForm",
  CAPTION: "caption",
  SECONDARY_SM: "secondarySmall"
};
